import { useMemo, useEffect, useState } from "react";
import Image from "next/image";
import { useRouter } from 'next/router';
import Head from "next/head";
import {NavLink} from '../../ui'
import { pushRoute } from "@/lib/helpers/common";
import InfiniteScroll from "./InfiniteScroll";

type props={
    TotalPageCount : number;
    fetchMoreData?:(pageNo:number)=>void
}

const DOTS = '...';
export function Pagination({TotalPageCount,fetchMoreData }:props ){
    const router = useRouter();
    const [currentPage, setCurrentPage]=useState(parseInt((router.query && router.query.page || "1").toString()));
    const [dotPages]=useState<Array<number>>([]);
	const siteURL= process.env.SITE_URL;
  
    useEffect(()=>{
        const page=parseInt((router.query && router.query.page || "1").toString());
        if(page==1 && router.query && router.query.page)
        {          
            delete router.query.page;
            router.push(router,undefined, { shallow: true });
        }
        setCurrentPage(page);
    },[router.query && router.query.page||1])

    const siblingCount =2;
    const range = (start:number, end:number) => {
        let length = end - start + 1;
        return Array.from({ length }, (_, idx) => idx + start);
      };

    const paginationRange = useMemo(() => {
        const totalPageCount =Math.ceil(TotalPageCount);// Math.ceil(TotalCount / PageSize);
        const totalPageNumbers = siblingCount + 5;

        dotPages.length=0;
        for(let dp=1; dp<= totalPageCount; dp++)
            dotPages.push(dp);

        if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }

        const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
        const rightSiblingIndex = Math.min(
            currentPage + siblingCount,
            totalPageCount
        );

        const shouldShowLeftDots = leftSiblingIndex > 2;
        const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

        const firstPageIndex = 1;
        const lastPageIndex = totalPageCount;

        if (!shouldShowLeftDots && shouldShowRightDots) {
            let leftItemCount = 3 + 2 * siblingCount;
            let leftRange = range(1, leftItemCount);
      
            return [...leftRange, DOTS, totalPageCount];
          }
      
          if (shouldShowLeftDots && !shouldShowRightDots) {
            let rightItemCount = 3 + 2 * siblingCount;
            let rightRange = range(
              totalPageCount - rightItemCount + 1,
              totalPageCount
            );
            return [firstPageIndex, DOTS, ...rightRange];
          }
      
          if (shouldShowLeftDots && shouldShowRightDots) {
            let middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
          }
          if(!shouldShowLeftDots && !shouldShowRightDots){
            let middleRange = range(firstPageIndex, lastPageIndex);
            return [...middleRange]
          }
         
     }, [TotalPageCount, siblingCount, currentPage]);
     
     if (currentPage === 0 || paginationRange!.length < 2)
        return null;

    const onChange = (pageNo:number) => {
        //onPageChange(pageNo);
        if(pageNo !== 1)
            router.query.page=`${pageNo}`;
        else
            delete router.query.page;
        router.push(router,undefined, { shallow: true });        
        window.scrollTo(0, 0);
    };

    const onNext = () => {      
       pushRoute(getURL(currentPage + 1));       
    };
    
    const onPrevious = () => {
       pushRoute(getURL(currentPage - 1));  
    };    

    const getURL=(pageNo:number)=>{
        let _url=router.asPath;
        const _isQuery=_url.split("?").length>1; 
        const _pageIdx=_url.indexOf("page=");
              
        if(_isQuery && _pageIdx > -1)
        {
            if(pageNo==1)
                return _url.substring(0,_pageIdx-1);
            else
                return _url.substring(0,_pageIdx)+`page=${pageNo}`;
        }
        else
        {
            if(pageNo==1)
                return _url;
            else
                return `${_url}${_isQuery?"&":"?"}page=${pageNo}`;
        }
    }
    
    let lastPage = paginationRange![paginationRange!.length - 1];

    const getHeadLink=()=>{
        const prev=(currentPage-1)>0 ? currentPage-1 : 0;
        const next=currentPage==lastPage ? 0 : currentPage+1;
        if(prev==0 && next > 0)
            return <link rel="next" href={`${siteURL}${getURL(next)}`} /> 
        else
        {
            return <>
                   {<link rel="prev" href={`${siteURL}${getURL(prev)}`} />}
                   { next > 0 && <link rel="next" href={`${siteURL}${getURL(next)}`} />}
                </>
        }
    }
    

    return <>
        <Head>
            {
                getHeadLink()
            }
        </Head>
       {fetchMoreData && <InfiniteScroll fetchMoreData={fetchMoreData} TotalPageCount={TotalPageCount}/>}
        <div className="pagination">
            {
                currentPage === 1? null : <button type="button" onClick={onPrevious} className="previous"><Image
                    src="/assets/images/arrow-left.svg"
                    height={16}
                    width={16}
                    alt="arrow"
                    className="img-responsive"
                     /></button>
            }                    
            <ul>
                {
                    paginationRange?.map((pageNumber, idx) => {
                        if (pageNumber === DOTS)
                            return <li key={idx}>&#8230;</li>;

                        const _index = dotPages.indexOf(parseInt(pageNumber.toString()));
                        if(_index>-1)
                            dotPages.splice(_index,1);
                        if(pageNumber==currentPage) {               
                            return  <li key={idx} className="active" style={{cursor:"default"}}>{pageNumber}</li>
                        }else
                            return (<li key={idx}><NavLink href={siteURL+ getURL(parseInt(pageNumber.toString()))} rel='nofollow'>{pageNumber}</NavLink> </li>)
                    })
                }
            </ul>
            {                    
                currentPage === lastPage ? null : <button type="button" onClick={onNext} className="next"><Image
                    src="/assets/images/arrow-left.svg"
                    height={16}
                    width={16}
                    alt="arrow"
                    className="img-responsive"
                     /></button>
            }
        </div>        
    </>;
}




